import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaMapMarkerAlt, FaPhone, FaFax, FaEnvelope, FaGlobe, FaFileInvoice } from 'react-icons/fa';
import './Impressum.css';

const Impressum = () => {
  const { t } = useTranslation();

  return (
    <div className="impressum-page">
      {/* Header Section */}
      <section className="impressum-header">
        <div className="impressum-header-overlay"></div>
        <div className="container">
          <h1>Impressum</h1>
          <p>{t('impressum.subtitle')}</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="impressum-content">
        <div className="container">
          <div className="impressum-grid">
            {/* Company Info Card */}
            <div className="impressum-card main-card">
              <div className="card-header">
                <h2>{t('impressum.company')}</h2>
              </div>
              <div className="card-body">
                <h3 className="company-name">PASA Lebensmittel GmbH</h3>
                <div className="info-group">
                  <div className="info-item">
                    <FaMapMarkerAlt className="info-icon" />
                    <div className="info-text">
                      <strong>Adresse</strong>
                      <p>Banksstraße 28</p>
                      <p>Großmarkt Stand 252 Ost F</p>
                      <p>20097 Hamburg</p>
                      <p>Deutschland</p>
                    </div>
                  </div>
                </div>
                
                {/* Management */}
                <div className="info-group mt-4">
                  <div className="info-item">
                    <div className="info-text">
                      <strong>Vertreten durch die Geschäftsführer:</strong>
                      <p>Mehmet Maksut Kurt</p>
                      <p>Meral Erikli</p>
                    </div>
                  </div>
                </div>

                {/* Register Entry */}
                <div className="info-group mt-4">
                  <div className="info-item">
                    <div className="info-text">
                      <strong>Registereintrag:</strong>
                      <p>Eingetragen im Handelsregister.</p>
                      <p><strong>Registergericht:</strong> Amtsgericht Hamburg</p>
                      <p><strong>Registernummer:</strong> HRB 102589</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Card */}
            <div className="impressum-card">
              <div className="card-header">
                <h2>Kontakt</h2>
              </div>
              <div className="card-body">
                <div className="contact-list">
                  <div className="contact-item">
                    <FaPhone className="contact-icon" />
                    <div>
                      <strong>Telefon</strong>
                      <p><a href="tel:+494032527151">040 32527151</a></p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <FaFax className="contact-icon" />
                    <div>
                      <strong>Fax</strong>
                      <p>040 32527153</p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <FaEnvelope className="contact-icon" />
                    <div>
                      <strong>E-Mail</strong>
                      <p><a href="mailto:info@pasalebensmittel.com">info@pasalebensmittel.com</a></p>
                    </div>
                  </div>
                  <div className="contact-item">
                    <FaGlobe className="contact-icon" />
                    <div>
                      <strong>Internet</strong>
                      <p><a href="https://www.pasalebensmittel.de" target="_blank" rel="noopener noreferrer">www.pasalebensmittel.de</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tax Info Card */}
            <div className="impressum-card tax-card">
              <div className="card-header">
                <h2>Umsatzsteuer-Identifikationsnummer</h2>
              </div>
              <div className="card-body">
                <div className="tax-info">
                  <div className="tax-item">
                    <FaFileInvoice className="tax-icon" />
                    <div>
                      <strong>Umsatzsteuer-Identifikationsnummer gemäß §27a Umsatzsteuergesetz:</strong>
                      <p className="tax-number">DE 25725766</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Legal Notice */}
            <div className="impressum-card legal-card">
              <div className="card-header">
                <h2>Rechtliche Hinweise</h2>
              </div>
              <div className="card-body">
                <p className="legal-text">
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                </p>
                <p className="legal-text mt-3">
                  <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong><br/>
                  PASA Lebensmittel GmbH<br/>
                  Banksstraße 28, Großmarkt Stand 252 Ost F<br/>
                  20097 Hamburg
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;

